import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2, CheckCircle2, XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function VerifyEmailPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [errMsg, setErrMsg] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) {
      setStatus('error');
      setErrMsg('This verification link is missing or invalid.');
      return;
    }
    axios.get(`${API}/auth/verify-email`, { params: { token } })
      .then(() => setStatus('success'))
      .catch((err) => {
        setStatus('error');
        const detail = err?.response?.data?.detail;
        setErrMsg(typeof detail === 'string' ? detail : 'Could not verify your email.');
      });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4">
      <div className="text-center max-w-sm" data-testid="verify-email-card">
        {status === 'loading' && (
          <>
            <Loader2 className="w-8 h-8 mx-auto animate-spin text-neutral-700" />
            <p className="mt-3 text-sm text-neutral-600">Verifying your email…</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle2 className="w-10 h-10 mx-auto text-emerald-600" />
            <h1 className="font-display text-2xl mt-3">Email verified</h1>
            <p className="text-sm text-neutral-500 mt-1">Thanks — your account is now fully set up.</p>
            <Button onClick={() => navigate('/build')} className="mt-5 rounded-full" data-testid="verify-go-build">Start building</Button>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-10 h-10 mx-auto text-red-500" />
            <h1 className="font-display text-2xl mt-3">Verification failed</h1>
            <p className="text-sm text-neutral-500 mt-1">{errMsg}</p>
            <Button onClick={() => navigate('/')} variant="outline" className="mt-5 rounded-full" data-testid="verify-back-home">Back to Transformerus</Button>
          </>
        )}
      </div>
    </div>
  );
}
